<template>
  <div class="resultsV2-style-segment">
    <div class="resultsV2-style-description">
      <span class="resultsV2-style-description-title">Comment travaillez-vous en équipe ?</span>
      <div class="resultsV2-style-description-subtitle">
        <span>
          En équipe, vous privilégiez 
          <span class="resultsV2-team-colour"> {{getStyle()}}</span>.
        </span>
      </div>
      <div class="resultsV2-style-description-text"> {{getStyleDescription()}} </div>
      <div class="resultsV2-style-keys-segment">
        <div class="resultsV2-style-keys-back resultsV2-team-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey1()}} </span></div>
        <div class="resultsV2-style-keys-back resultsV2-team-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey2()}} </span></div>
        <div class="resultsV2-style-keys-back resultsV2-team-bg-colour"><span
            class="resultsV2-style-keys-text">{{getStyleKey3()}} </span></div>
      </div>
    </div>
    <div class="resultsV2-style-graph-area">
      <div class="resultsV2-style-box4 resultsV2-style-box4-top-left" :class="getSelectBGClass('Rigorous')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Rigorous')">
          Rigueur
        </span>
      </div>
      <div class="resultsV2-style-box4 resultsV2-style-box4-top-right" :class="getSelectBGClass('Collaborator')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Collaborator')">
          Collaboration
        </span>
      </div>
      <div class="resultsV2-style-box4-center " :class="getSelectBGClass('Undetermined')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Undetermined')">
          Flexibilité
        </span>
      </div>
      <div class="resultsV2-style-box4 resultsV2-style-box4-bottom-left" :class="getSelectBGClass('Balanced')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Balanced')">
          Indépendance
        </span>
      </div>
      <div class="resultsV2-style-box4 resultsV2-style-box4-bottom-right" :class="getSelectBGClass('Spontaneous')">
        <span class="resultsV2-style-box4-text" :class="getSelectClass('Spontaneous')">
          Spontanéité
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['style', 'domination'],
  methods: {
    getStyle() {
      var text = "";
      switch (this.style) {
        case 'Rigorous':
        text = "la rigueur";
          break;
        case 'Collaborator':
        text = "la collaboration";
          break;
        case 'Balanced':
        text = "l'indépendance";
          break;
        case 'Spontaneous':
        text = "la spontanéité";
          break;
        case 'Undetermined':
        text = "la flexibilité";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleDescription() {
      var text = "";
      switch (this.style) {
        case 'Rigorous':
        text = "Votre approche du travail collectif se caractérise par un niveau élevé d'exigence et de précision dans chacune de vos contributions. Cette rigueur méthodique se manifeste à travers une attention particulière aux détails et un souci constant de la qualité. Vous établissez naturellement des standards élevés qui inspirent vos collaborateurs à améliorer leur propre niveau d'exigence. Cette fiabilité exemplaire dans vos engagements et votre travail fait de vous un pilier sur lequel l'équipe peut s'appuyer en toute confiance. Votre méticulosité contribue significativement à l'excellence collective tout en renforçant la crédibilité de l'équipe dans son ensemble.";
          break;
        case 'Collaborator':
        text = "Votre approche du travail en équipe se distingue par une remarquable capacité à créer des synergies positives entre les membres du groupe. Vous excellez dans l'art de tisser des liens professionnels constructifs, favorisant naturellement le partage des connaissances et des compétences. Cette orientation collaborative se traduit par une aptitude à identifier et valoriser les forces de chacun pour les mettre au service du collectif. Vous créez un environnement où la coopération devient naturelle et enrichissante, permettant l'émergence d'une intelligence collective qui dépasse la simple somme des contributions individuelles. Votre présence catalyse les énergies positives et renforce la cohésion du groupe.";
          break;
        case 'Balanced':
        text = "Votre style de travail en équipe se caractérise par une autonomie marquée qui enrichit la dynamique collective. Vous apportez une touche personnelle unique tout en restant aligné avec les objectifs du groupe. Cette capacité à travailler de manière autonome, tout en maintenant des liens constructifs avec l'équipe, crée un équilibre précieux entre initiative individuelle et cohésion collective. Votre approche proactive dans la prise en charge des responsabilités, combinée à une conscience aiguë des besoins du groupe, permet d'optimiser l'efficacité globale de l'équipe tout en préservant votre espace de créativité et d'innovation personnelle.";
          break;
        case 'Spontaneous':
        text = "Votre façon d'interagir en équipe se distingue par une remarquable capacité d'adaptation instantanée aux situations. Cette spontanéité naturelle vous permet de réagir avec pertinence aux imprévus et d'apporter une dynamique rafraîchissante au groupe. Vous excellez dans l'art de rebondir face aux situations inattendues, transformant souvent les défis en opportunités grâce à votre vivacité d'esprit. Cette approche intuitive du travail collectif, combinée à votre réactivité, apporte une flexibilité précieuse à l'équipe tout en maintenant une atmosphère positive et énergique, même dans les moments de tension.";
          break;
        case 'Undetermined':
        text = "Votre approche du travail en équipe se caractérise par une capacité d'adaptation équilibrée aux changements et aux besoins du groupe. Vous savez ajuster votre style de travail et vos méthodes tout en maintenant un cadre structuré qui favorise l'efficacité collective. Cette flexibilité mesurée vous permet de concilier les différentes façons de travailler au sein de l'équipe, facilitant ainsi la collaboration entre des profils variés. Votre aptitude à trouver un compromis entre stabilité et adaptabilité contribue à la résilience de l'équipe face aux évolutions, tout en préservant la continuité nécessaire à l'atteinte des objectifs communs.";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey1() {
      var text = "";
      switch (this.style) {
        case 'Rigorous':
        text = "Discipline";
          break;
        case 'Collaborator':
        text = "Synergie";
          break;
        case 'Balanced':
        text = "Autonomie";
          break;
        case 'Spontaneous':
        text = "Instinct";
          break;
        case 'Undetermined':
        text = "Adaptation";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey2() {
      var text = "";
      switch (this.style) {
        case 'Rigorous':
        text = "Précision";
          break;
        case 'Collaborator':
        text = "Partage";
          break;
        case 'Balanced':
        text = "Liberté";
          break;
        case 'Spontaneous':
        text = "Réactivité";
          break;
        case 'Undetermined':
        text = "Souplesse";
          break;
        default:
          break;
      }
      return text;
    },
    getStyleKey3() {
      var text = "";
      switch (this.style) {
        case 'Rigorous':
        text = "Fiabilité";
          break;
        case 'Collaborator':
        text = "Alliance";
          break;
        case 'Balanced':
        text = "Initiative";
          break;
        case 'Spontaneous':
        text = "Improvisation";
          break;
        case 'Undetermined':
        text = "Équilibre";
          break;
        default:
          break;
      }
      return text;
    },
    getSelectClass(style) {
      var text = "";
      if  (this.style == style) {
        text = "resultsV2-style-box4-text-selected";
      }
      return text;
    },
    getSelectBGClass(style) {
      var text = "";
      if  (this.style == style) {
        switch (this.domination) {
          case "Neutral":            
              text = "resultsV2-team-bg-colour";
            break;
          case "Submissive":            
              text = "resultsV2-team-bg-colour";
            break;
          case "Dominant":            
              text = "resultsV2-team-bg-colour";
            break;
        
          default:
            break;
        }
      }
      return text;
    },
  }
};
</script>

<style>
.resultsV2-team-colour {
  color: #FF97DA;
}
.resultsV2-team-bg-colour {
  background: linear-gradient(180deg, #ff96d9, #f164be)!important;
}

/* .resultsV2-team-bg-colour-neutral {
  background: linear-gradient(151.64deg, #e2e2e2, #d5e6f0)!important;
}
.resultsV2-team-bg-colour-submissive {
  background: linear-gradient(151.64deg, #7ad2ff, #4fbaf0)!important;
}
.resultsV2-team-bg-colour-dominant {
  background: linear-gradient(151.64deg, #ff7acc, #f04fe8)!important;
} */
</style>